// app/javascript/controllers/promotions_controller.js
// Promotions modal — triggered by ?ad=<slug> URL parameters from ad campaigns.
// Fetches modal content from local proxy (/api/v1/promotions/:slug), renders a
// dismissible modal with CTA buttons, share panel, and event tracking.
(function () {
  var LOG = "[Promotions]";

  // ====== CONFIG ======
  var STORAGE_PREFIX = "stint_modal_";
  var PROXY_PROMOTIONS = "/api/v1/promotions/";
  var PROXY_EVENTS     = "/api/v1/events";

  // Rails action name → promotion target page name
  var ACTION_TO_PAGE = {
    index:            "partners",
    index_stinter:    "stinters",
    index_workforce:  "workforce",
    contact:          "contact",
    our_story:        "story"
  };

  // ====== LOGGING ======
  function log()  { console.log.apply(console, [LOG].concat(Array.prototype.slice.call(arguments))); }
  function warn() { console.warn.apply(console, [LOG].concat(Array.prototype.slice.call(arguments))); }
  function err()  { console.error.apply(console, [LOG].concat(Array.prototype.slice.call(arguments))); }

  // ====== SESSION ID ======
  function generateUUID() {
    try {
      if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
      }
    } catch (e) {}
    // Fallback for HTTP contexts / older browsers
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  function getSessionId() {
    try {
      var sid = localStorage.getItem("stint_session_id");
      if (!sid) {
        sid = generateUUID();
        localStorage.setItem("stint_session_id", sid);
        log("Generated new session_id:", sid);
      }
      return sid;
    } catch (e) {
      return generateUUID();
    }
  }

  // ====== REFERRER SESSION ======
  // Reads ?ref=<session_id> from the URL — set by whoever shared the link.
  // Returned value is sent with every event as referrer_session_id so we
  // can trace the viral chain back to the original sharer.
  function getReferrerSession() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get("ref") || null;
    } catch (e) {
      return null;
    }
  }

  // ====== HELPERS ======
  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function getStorageKey(slug) {
    return STORAGE_PREFIX + slug;
  }

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  }

  function isMobile() {
    return /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  }

  function stripEmoji(str) {
    return str
      .replace(/[\u{1F000}-\u{1FFFF}\u{2600}-\u{2BFF}\u{FE00}-\u{FEFF}]/gu, '')
      .replace(/ {2,}/g, ' ')
      .trim();
  }

  // ====== STORAGE ======
  function getDismissalRecord(slug) {
    var key = getStorageKey(slug);

    // Check sessionStorage first (for "session" duration)
    var sessionData = sessionStorage.getItem(key);
    if (sessionData) {
      try {
        var rec = JSON.parse(sessionData);
        log("Found session dismissal for", slug, rec);
        return rec;
      } catch (e) { /* ignore */ }
    }

    // Then localStorage
    var localData = localStorage.getItem(key);
    if (localData) {
      try {
        var record = JSON.parse(localData);
        // Check expiry — if expired, remove and treat as no dismissal
        if (record.expires_at && new Date(record.expires_at) < new Date()) {
          log("Dismissal expired for", slug, "— removing");
          localStorage.removeItem(key);
          return null;
        }
        log("Found local dismissal for", slug, record);
        return record;
      } catch (e) {
        localStorage.removeItem(key);
      }
    }
    log("No dismissal record for", slug);
    return null;
  }

  function saveDismissal(slug, version, storageDuration, endsAt) {
    try {
      var key = getStorageKey(slug);
      var record = { version: version, dismissed_at: new Date().toISOString() };

      if (storageDuration === "session") {
        log("Saving session dismissal for", slug);
        sessionStorage.setItem(key, JSON.stringify(record));
        return;
      }

      if (storageDuration === "campaign" && endsAt) {
        record.expires_at = endsAt;
      } else {
        var days;
        switch (storageDuration) {
          case "1d":  days = 1;  break;
          case "3d":  days = 3;  break;
          case "30d": days = 30; break;
          default:    days = 7;  break;
        }
        record.expires_at = addDays(new Date(), days).toISOString();
      }

      log("Saving local dismissal for", slug, "expires:", record.expires_at);
      localStorage.setItem(key, JSON.stringify(record));
    } catch (e) {
      warn("saveDismissal failed (storage unavailable?):", e);
    }
  }

  function saveImpression(slug, version, storageDuration, endsAt, currentRecord) {
    try {
      var key   = getStorageKey(slug);
      var count = (currentRecord && currentRecord.impression_count) || 0;
      var record = {
        version:          version,
        impression_count: count + 1,
        shown_at:         new Date().toISOString()
      };
      if (storageDuration === "session") {
        sessionStorage.setItem(key, JSON.stringify(record));
        return;
      }
      if (storageDuration === "campaign" && endsAt) {
        record.expires_at = endsAt;
      } else {
        var days;
        switch (storageDuration) {
          case "1d":  days = 1;  break;
          case "3d":  days = 3;  break;
          case "30d": days = 30; break;
          default:    days = 7;  break;
        }
        record.expires_at = addDays(new Date(), days).toISOString();
      }
      log("Saving impression", record.impression_count, "for", slug);
      localStorage.setItem(key, JSON.stringify(record));
    } catch (e) {
      warn("saveImpression failed (storage unavailable?):", e);
    }
  }

  function saveNavCta(promo, storageDuration) {
    try {
      var ap = promo.cta && promo.cta.apply;
      if (!ap || !ap.enabled || !ap.url) return;

      var record = {
        slug:          promo.slug,
        campaign_slug: promo.campaign_slug || null,
        apply_url:     ap.url,
        apply_label:   ap.label || "Apply Now",
        expires_at:    null
      };

      if (storageDuration === "session") {
        sessionStorage.setItem("stint_promo_nav", JSON.stringify(record));
        return;
      }

      if (storageDuration === "campaign" && promo.campaign_ends_at) {
        record.expires_at = promo.campaign_ends_at;
      } else {
        var days;
        switch (storageDuration) {
          case "1d":  days = 1;  break;
          case "3d":  days = 3;  break;
          case "30d": days = 30; break;
          default:    days = 7;  break;
        }
        record.expires_at = addDays(new Date(), days).toISOString();
      }
      log("Saving nav CTA for", promo.slug, "expires:", record.expires_at);
      localStorage.setItem("stint_promo_nav", JSON.stringify(record));
    } catch (e) {
      warn("saveNavCta failed (storage unavailable?):", e);
    }
  }

  // ====== EXTERNAL ANALYTICS ======
  function trackExternalAnalytics(eventType, metadata) {
    var ch = (metadata && metadata.channel) || null;

    // ── GA4 ──
    try {
      if (typeof window.gtag === "function") {
        if (eventType === "cta_download_app") {
          window.gtag("event", "app_download", { event_category: "promo_modal", event_label: "download_app" });
        } else if (eventType === "cta_apply") {
          window.gtag("event", "generate_lead", { event_category: "promo_modal", event_label: "apply" });
        } else if (eventType === "cta_share") {
          window.gtag("event", "share", { method: ch || "unknown", content_type: "promo_modal" });
        } else if (eventType === "nav_apply_click") {
          window.gtag("event", "generate_lead", { event_category: "promo_nav", event_label: "nav_apply" });
        }
      }
    } catch(e) {}

    // ── Meta Pixel ──
    try {
      if (typeof window.fbq === "function") {
        if (eventType === "cta_download_app") {
          window.fbq("track", "Lead", { content_name: "app_download", content_category: "promo_modal" });
        } else if (eventType === "cta_apply") {
          window.fbq("track", "Lead", { content_name: "apply", content_category: "promo_modal" });
        } else if (eventType === "cta_share") {
          window.fbq("trackCustom", "Share", { channel: ch || "unknown", content_category: "promo_modal" });
        } else if (eventType === "nav_apply_click") {
          window.fbq("track", "Lead", { content_name: "nav_apply", content_category: "promo_nav" });
        }
      }
    } catch(e) {}

    // ── Fathom ──
    try {
      if (typeof window.fathom === "object" && typeof window.fathom.trackEvent === "function") {
        if (eventType === "cta_download_app") {
          window.fathom.trackEvent("Promo: Download App");
        } else if (eventType === "cta_apply") {
          window.fathom.trackEvent("Promo: Apply Now (Modal)");
        } else if (eventType === "cta_share") {
          window.fathom.trackEvent("Promo: Share via " + (ch || "unknown"));
        } else if (eventType === "nav_apply_click") {
          window.fathom.trackEvent("Promo: Apply Now (Nav)");
        }
      }
    } catch(e) {}

    // ── TikTok Pixel ──
    try {
      if (typeof window.ttq === "object" && typeof window.ttq.track === "function") {
        if (eventType === "cta_download_app") {
          window.ttq.track("Download", { content_name: "promo_modal_download" });
        } else if (eventType === "cta_apply") {
          window.ttq.track("SubmitForm", { content_name: "promo_modal_apply" });
        } else if (eventType === "cta_share") {
          window.ttq.track("Share", { content_name: "promo_modal_share", channel: ch || "unknown" });
        } else if (eventType === "nav_apply_click") {
          window.ttq.track("SubmitForm", { content_name: "promo_nav_apply" });
        }
      }
    } catch(e) {}
  }

  // ====== EVENT TRACKING ======
  function trackEvent(eventType, promotionSlug, campaignSlug, metadata) {
    var eventData = {
      event_type:      eventType,
      promotion_slug:  promotionSlug,
      campaign_slug:   campaignSlug || null,
      session_id:      getSessionId(),
      page_url:        window.location.href,
      metadata:        metadata || {}
    };

    // Attach referrer so viral chain can be reconstructed server-side
    var ref = getReferrerSession();
    if (ref) eventData.referrer_session_id = ref;

    var payload = { event: eventData };

    log("Tracking event:", eventType, payload);

    fetch(PROXY_EVENTS, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(payload)
    })
    .then(function (resp) {
      if (!resp.ok) {
        warn("Event tracking failed:", resp.status, resp.statusText);
        return resp.text().then(function (t) { warn("Event response body:", t); });
      }
      log("Event tracked successfully:", eventType);
    })
    .catch(function (e) {
      warn("Event tracking error:", e);
    });

    // Fire external analytics for conversion events
    if (eventType === "cta_download_app" || eventType === "cta_apply" ||
        eventType === "cta_share"         || eventType === "nav_apply_click") {
      trackExternalAnalytics(eventType, metadata);
    }
  }

  // ====== URL PARAMS ======
  function getPromoParams() {
    var params = new URLSearchParams(window.location.search);
    var slug = params.get("ad");
    if (!slug) return null;

    log("Found ad param:", slug);
    return {
      slug: slug,
      storage: params.get("storage") || null,
      page: params.get("page") || null
    };
  }

  // ====== PAGE TARGETING ======
  function getCurrentPageName() {
    var body = document.querySelector("body");
    var action = body ? body.dataset.action : null;
    var page = ACTION_TO_PAGE[action] || null;
    log("Current page:", action, "→", page);
    return page;
  }

  function isPageTargeted(targetPages, overridePage) {
    if (overridePage === "all") {
      log("Page override: all — showing everywhere");
      return true;
    }

    if (!targetPages || targetPages.length === 0) {
      log("No target_pages — showing everywhere");
      return true;
    }
    if (targetPages.indexOf("all") !== -1) {
      log("target_pages includes 'all' — showing everywhere");
      return true;
    }

    if (overridePage) {
      var overrides = overridePage.split(",");
      var currentPage = getCurrentPageName();
      var match = currentPage && overrides.indexOf(currentPage) !== -1;
      log("Page override:", overrides, "current:", currentPage, "match:", match);
      return match;
    }

    var currentPage = getCurrentPageName();
    var match = currentPage && targetPages.indexOf(currentPage) !== -1;
    log("Page targeting:", targetPages, "current:", currentPage, "match:", match);
    return match;
  }

  // ====== CTA BUTTON RENDERING ======

  // Mirrors dashboard's cta_text_color: only #121212 (black) gets white text.
  function ctaTextColor(bgHex) {
    return (bgHex || "").toLowerCase() === "#121212" ? "#ffffff" : "#121212";
  }

  function buildCtaButtons(cta, promo) {
    if (!cta) return "";

    var html = '<div class="promo-cta-buttons">';

    // Download App button
    if (cta.download_app && cta.download_app.enabled) {
      var da = cta.download_app;
      var links = da.links || [];
      var targetPlatform = isIOS() ? "ios" : "android";
      var appLink = null;
      for (var li = 0; li < links.length; li++) {
        if (links[li].platform === targetPlatform) { appLink = links[li]; break; }
      }
      if (!appLink && links.length > 0) appLink = links[0];
      if (appLink && appLink.url) {
        var daBg  = da.color || "#16E990";
        var isStinterApp = appLink.url.indexOf("1350133141") !== -1 ||
                           appLink.url.indexOf("com.stint.stint") !== -1;
        var locale = (document.body.dataset.locale || "en-gb").toLowerCase();
        var href   = isStinterApp ? ("/" + locale + "/redirect_to_app") : appLink.url;
        html += '<a href="' + escapeHtml(href) + '" target="_blank" rel="noopener"' +
          ' class="promo-cta-btn"' +
          ' style="background-color:' + escapeHtml(daBg) + ';color:' + ctaTextColor(daBg) + ';"' +
          ' data-event="cta_download_app">' +
          escapeHtml(da.label || "Download the App") + '</a>';
      }
    }

    // Share button (opens share panel) — rendered before Apply to match dashboard order
    if (cta.share && cta.share.enabled) {
      var sh = cta.share;
      var shBg = sh.color || "#A49EF2";
      html += '<button type="button" ' +
        'class="promo-cta-btn" ' +
        'style="background-color:' + escapeHtml(shBg) + ';color:' + ctaTextColor(shBg) + ';" ' +
        'data-action="open-share">' +
        escapeHtml(sh.label || "Share with a Friend") + '</button>';
    }

    // Apply button
    if (cta.apply && cta.apply.enabled) {
      var ap = cta.apply;
      var apBg = ap.color || "#121212";
      html += '<a href="' + escapeHtml(ap.url || "#") + '" target="_blank" rel="noopener" ' +
        'class="promo-cta-btn" ' +
        'style="background-color:' + escapeHtml(apBg) + ';color:' + ctaTextColor(apBg) + ';" ' +
        'data-event="cta_apply">' +
        escapeHtml(ap.label || "Apply Now") + '</a>';
    }

    html += '</div>';
    return html;
  }

  // ====== SHARE PANEL ======
  function buildSharePanel(cta) {
    if (!cta || !cta.share || !cta.share.enabled || !cta.share.template) return "";

    var tpl = cta.share.template;
    var sessionId = getSessionId();
    var channels = [];

    // Append ?ref=<session_id> to each short link URL so recipients are attributed
    // to this sharer when they land on the landing page.
    function withRef(url) {
      if (!url) return url;
      return url + (url.indexOf("?") !== -1 ? "&" : "?") + "ref=" + encodeURIComponent(sessionId);
    }

    function messageWithRef(message, originalUrl, refUrl) {
      if (!message || !originalUrl) return message;
      // Replace the last occurrence of the bare URL with the ref-tagged version
      return message.split(originalUrl).join(refUrl);
    }

    var iconWhatsApp = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path fill="#25D366" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>';
    var iconTelegram = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path fill="#26A5E4" d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>';
    var iconSignal   = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-hidden="true"><path fill="#3A76F0" fill-rule="nonzero" d="m194.56 7.48 5.76 23.28c-22.66 5.57-44.34 14.54-64.32 26.6l-12.32-20.56c22.01-13.29 45.91-23.18 70.88-29.32zm117.12 23.28c22.66 5.57 44.34 14.54 64.32 26.6l12.4-20.56c-22.04-13.3-45.96-23.18-70.96-29.32zm-274.88 92.91c-13.29 22.01-23.18 45.91-29.32 70.87l23.28 5.76c5.57-22.65 14.54-44.34 26.6-64.31zm-10.2 97.55-23.72-3.6c-3.84 25.43-3.84 51.29 0 76.72l23.72-3.6c-3.47-22.99-3.47-46.53 0-69.52zm349.4 233.38c-19.95 12.05-41.61 21.02-64.24 26.6l5.76 23.28c24.94-6.15 48.81-16.03 70.8-29.32zm109.4-163.86 23.72 3.6c3.84-25.43 3.84-51.29 0-76.72l-23.72 3.6c3.47 22.99 3.47 46.53 0 69.52zm-4.16 20.92c-5.57 22.65-14.54 44.34-26.6 64.31l20.56 12.4c13.3-22.04 23.18-45.96 29.32-70.95zm-190.48 173.74c-23.04 3.47-46.48 3.47-69.52 0l-3.6 23.72c25.43 3.84 51.29 3.84 76.72 0zm152-91.79c-13.84 18.74-30.41 35.29-49.16 49.11l14.24 19.32c20.69-15.21 38.97-33.43 54.24-54.07zm-49.16-324.37c18.75 13.83 35.33 30.4 49.16 49.15l19.32-14.4c-15.22-20.63-33.45-38.85-54.08-54.07zm-324.36 49.15c13.83-18.75 30.41-35.32 49.16-49.15l-14.4-19.32c-20.63 15.22-38.86 33.44-54.08 54.07zm385.4 17.6c12.05 19.95 21.02 41.61 26.6 64.23l23.28-5.76c-6.15-24.93-16.04-48.8-29.32-70.79zm-233.4-109.39c23.04-3.47 46.48-3.47 69.52 0l3.6-23.72c-25.43-3.84-51.29-3.84-76.72 0zm-139.68 441.8-49.56 11.56 11.56-49.55-23.36-5.48-11.56 49.55c-4.05 17.3 11.54 32.89 28.84 28.84l49.52-11.36zm-56.36-64.87 23.36 5.44 8-34.36c-11.66-19.6-20.35-40.81-25.8-62.95l-23.28 5.76c5.22 21.2 13.15 41.65 23.6 60.83zm77.64 59.99 5.44 23.36 25.28-5.88c19.18 10.45 39.63 18.38 60.84 23.6l5.76-23.28c-22.1-5.51-43.26-14.26-62.8-25.96zm-28.81-308.09c-36.59 66.25-34.3 147.14 5.97 211.22l-20 85.31 85.32-19.99c74.84 47.13 171.29 41.78 240.47-13.33 69.17-55.1 95.92-147.92 66.7-231.39-59.29-169.3-292.26-187.89-378.46-31.82z"/></svg>';
    var iconEmail    = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path fill="#6B7280" d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"/></svg>';

    var mobile = isMobile();

    if (tpl.whatsapp && tpl.whatsapp.message) {
      var waRefUrl = withRef(tpl.whatsapp.url);
      var waMsg    = messageWithRef(tpl.whatsapp.message, tpl.whatsapp.url, waRefUrl);
      if (!mobile) waMsg = stripEmoji(waMsg);
      channels.push({
        name: "whatsapp", label: "WhatsApp", icon: iconWhatsApp,
        href: "https://wa.me/?text=" + encodeURIComponent(waMsg)
      });
    }
    if (tpl.whatsapp && tpl.whatsapp.message) {
      var tgRefUrl = withRef(tpl.whatsapp.url);
      var tgMsg    = messageWithRef(tpl.whatsapp.message, tpl.whatsapp.url, tgRefUrl);
      if (!mobile) tgMsg = stripEmoji(tgMsg);
      channels.push({
        name: "telegram", label: "Telegram", icon: iconTelegram,
        href: "https://t.me/share/url?url=" + encodeURIComponent(tgRefUrl) + "&text=" + encodeURIComponent(tgMsg)
      });
    }
    if (tpl.whatsapp && tpl.whatsapp.message) {
      var sigRefUrl = withRef(tpl.whatsapp.url);
      var sigMsg    = messageWithRef(tpl.whatsapp.message, tpl.whatsapp.url, sigRefUrl);
      if (!mobile) sigMsg = stripEmoji(sigMsg);
      channels.push({
        name: "signal", label: "Signal", icon: iconSignal,
        href: "sgnl://send?text=" + encodeURIComponent(sigMsg)
      });
    }
    if (tpl.email && tpl.email.message) {
      var emlRefUrl = withRef(tpl.email.url);
      var emlMsg    = messageWithRef(tpl.email.message, tpl.email.url, emlRefUrl);
      var subject   = encodeURIComponent(tpl.title || "Check this out");
      channels.push({
        name: "email", label: "Email", icon: iconEmail,
        href: "mailto:?subject=" + subject + "&body=" + encodeURIComponent(emlMsg)
      });
    }

    if (channels.length === 0) return "";

    var html = '<div id="promo-share-panel" class="promo-share-panel" style="display:none;">';
    html += '<p class="promo-share-intro">' +
        'Know a student who needs to fund their ' +
        '<span class="promo-share-rotator">' +
          '<span class="promo-share-rotator__item">antics?</span>' +
          '<span class="promo-share-rotator__item">life?</span>' +
          '<span class="promo-share-rotator__item">nights out?</span>' +
          '<span class="promo-share-rotator__item">societies?</span>' +
          '<span class="promo-share-rotator__item">holidays?</span>' +
        '</span>' +
      '</p>' +
      '<p class="promo-share-desc">' +
        'Stint connects students to top brands in hospitality for flexible short shifts. ' +
        'Earn cash between classes, evenings and weekends. You call the shots.' +
      '</p>' +
      '<p class="promo-share-cta-line">Share Stint with them.</p>';
    html += '<div class="promo-share-channels">';
    for (var i = 0; i < channels.length; i++) {
      var ch = channels[i];
      html += '<a href="' + escapeHtml(ch.href) + '" target="_blank" rel="noopener" ' +
        'class="c-btn c-btn-outline--turn-purple border promo-share-channel" data-channel="' + ch.name + '">' +
        '<span class="promo-share-icon">' + ch.icon + '</span>' +
        '<span>' + escapeHtml(ch.label) + '</span></a>';
    }
    html += '</div>';
    html += '<button type="button" class="promo-share-back" data-action="close-share">← Back</button>';
    html += '</div>';

    return html;
  }

  // ====== MODAL RENDERING ======
  function showModal(promo, storageDuration, dismissalRecord) {
    try {
    log("Rendering modal for:", promo.slug, "version:", promo.version);

    var wrapper = document.createElement("div");
    wrapper.id = "promo-modal-wrapper";
    wrapper.className = "fixed inset-0 z-50";
    wrapper.style.display = "flex";
    wrapper.setAttribute("role", "dialog");
    wrapper.setAttribute("aria-modal", "true");

    var ctaHtml = buildCtaButtons(promo.cta, promo);
    var shareHtml = buildSharePanel(promo.cta);

    wrapper.innerHTML =
      '<div id="promo-modal-overlay" class="promo-overlay"></div>' +
      '<div class="promo-modal-positioner">' +
        '<div id="promo-modal-box" class="promo-modal-box">' +
          '<div class="promo-modal-inner">' +
            '<div class="promo-modal-header">' +
              (promo.title ? '<h2 class="promo-modal-title">' + escapeHtml(promo.title) + '</h2>' : '<span></span>') +
              '<button id="promo-modal-close" class="promo-modal-close" aria-label="Close">&times;</button>' +
            '</div>' +
            '<div id="promo-main-content">' +
              '<div class="promo-content">' + promo.content_html + '</div>' +
              ctaHtml +
            '</div>' +
            shareHtml +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(wrapper);
    document.body.style.overflow = "hidden";

    // Track modal_viewed
    trackEvent("modal_viewed", promo.slug, promo.campaign_slug);

    // Track impression for max_impressions feature (counted on show, not on dismiss)
    var maxImp = promo.max_impressions || null;
    if (maxImp) {
      saveImpression(promo.slug, promo.version, storageDuration, promo.campaign_ends_at, dismissalRecord);
    }

    // Persist apply URL so nav CTA can be shown on subsequent page loads
    saveNavCta(promo, storageDuration);

    // Reveal nav CTA immediately (analytics.js boot already ran before the fetch returned)
    try {
      var navAp = promo.cta && promo.cta.apply;
      if (navAp && navAp.enabled && navAp.url) {
        var navLabel = navAp.label || "Apply Now";
        var navDesktop = document.getElementById("nav-promo-apply-desktop");
        if (navDesktop) {
          navDesktop.setAttribute("href", navAp.url);
          navDesktop.textContent = navLabel;
          navDesktop.style.display = "";
        }
        var navMobile = document.getElementById("nav-promo-apply-mobile");
        if (navMobile) {
          var navMLink = navMobile.querySelector("a");
          if (navMLink) {
            navMLink.setAttribute("href", navAp.url);
            navMLink.textContent = navLabel;
          }
          navMobile.style.display = "";
        }
      }
    } catch (e) {}

    // ---- Dismiss logic ----
    function dismiss() {
      log("Modal dismissed for:", promo.slug);
      trackEvent("modal_dismissed", promo.slug, promo.campaign_slug);
      // Only save a hard dismissal when NOT using impression counting
      if (!maxImp) {
        saveDismissal(promo.slug, promo.version, storageDuration, promo.campaign_ends_at);
      }
      wrapper.remove();
      document.body.style.overflow = "";
    }

    // Close button
    var closeBtn = document.getElementById("promo-modal-close");
    if (closeBtn) closeBtn.addEventListener("click", dismiss);

    // Overlay click
    var overlay = document.getElementById("promo-modal-overlay");
    if (overlay) overlay.addEventListener("click", dismiss);

    // Escape key
    function onEscape(e) {
      if (e.key === "Escape") {
        dismiss();
        document.removeEventListener("keydown", onEscape);
      }
    }
    document.addEventListener("keydown", onEscape);

    // ---- CTA click tracking ----
    var box = document.getElementById("promo-modal-box");
    if (box) {
      box.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-event]");
        if (btn) {
          var eventType = btn.getAttribute("data-event");
          log("CTA clicked:", eventType);
          trackEvent(eventType, promo.slug, promo.campaign_slug);
        }
      });
    }

    // ---- Share panel toggle ----
    var mainContent = document.getElementById("promo-main-content");
    var sharePanel  = document.getElementById("promo-share-panel");

    if (box && mainContent && sharePanel) {
      box.addEventListener("click", function (e) {
        // Open share panel
        if (e.target.closest("[data-action='open-share']")) {
          log("Opening share panel");
          mainContent.style.display = "none";
          sharePanel.style.display = "block";
        }
        // Close share panel
        if (e.target.closest("[data-action='close-share']")) {
          log("Closing share panel");
          sharePanel.style.display = "none";
          mainContent.style.display = "block";
        }
        // Track share channel click
        var channel = e.target.closest("[data-channel]");
        if (channel) {
          var ch = channel.getAttribute("data-channel");
          log("Share channel clicked:", ch);
          trackEvent("cta_share", promo.slug, promo.campaign_slug, { channel: ch });
        }
      });
    }
    } catch (e) {
      err("showModal failed:", e);
    }
  }

  // ====== MAIN ======
  function init() {
    try {
    log("Initializing...");

    var promoParams = getPromoParams();
    if (!promoParams) {
      log("No ?ad= param found — exiting");
      return;
    }

    var slug = promoParams.slug;
    var sessionId = getSessionId();
    var pageUrl = window.location.href;

    // Check dismissal state before fetching
    var dismissal = getDismissalRecord(slug);

    // Build fetch URL with session_id and page_url
    var fetchUrl = PROXY_PROMOTIONS + encodeURIComponent(slug) +
      "?session_id=" + encodeURIComponent(sessionId) +
      "&page_url=" + encodeURIComponent(pageUrl);

    log("Fetching:", fetchUrl);

    fetch(fetchUrl, {
      headers: { "Accept": "application/json" }
    })
    .then(function (response) {
      log("Proxy responded:", response.status, response.statusText);
      if (!response.ok) {
        return response.text().then(function (t) {
          warn("Proxy error response:", t);
          return null;
        });
      }
      return response.json();
    })
    .then(function (data) {
      if (!data) {
        warn("No data returned from proxy");
        return;
      }

      log("API response:", JSON.stringify(data).substring(0, 500));

      // Handle clear_storage flag (campaign/promotion ended)
      if (data.clear_storage) {
        log("clear_storage flag set — clearing storage for", slug);
        localStorage.removeItem(getStorageKey(slug));
        sessionStorage.removeItem(getStorageKey(slug));
        localStorage.removeItem("stint_promo_nav");
        sessionStorage.removeItem("stint_promo_nav");
        return;
      }

      // Check if promotion is active
      if (!data.active) {
        log("Promotion is not active — skipping");
        return;
      }

      // Determine effective storage duration (URL param overrides API)
      var storageDuration = promoParams.storage || data.storage_duration || "7d";
      log("Storage duration:", storageDuration);

      // If the URL has a ?ref= param the user arrived via a shared link — always show
      var arrivedViaShare = !!getReferrerSession();
      if (arrivedViaShare) {
        log("?ref= present — bypassing dismissal check, showing modal");
      } else {
        var maxImpressions = data.max_impressions || null;
        if (dismissal && dismissal.version === data.version) {
          if (maxImpressions) {
            var impressionsDone = dismissal.impression_count || 0;
            if (impressionsDone >= maxImpressions) {
              log("Max impressions (" + maxImpressions + ") reached — skipping");
              return;
            }
            log("Impression " + (impressionsDone + 1) + " of " + maxImpressions + " — showing");
          } else {
            log("Already dismissed version", data.version, "— skipping");
            return;
          }
        } else if (dismissal) {
          log("Version changed from", dismissal.version, "to", data.version, "— showing again");
        }
      }

      // Check page targeting
      if (!isPageTargeted(data.target_pages, promoParams.page)) {
        log("Page not targeted — skipping");
        return;
      }

      // All checks passed — show modal
      log("All checks passed — showing modal");
      showModal(data, storageDuration, dismissal);
    })
    .catch(function (e) {
      err("Failed to load promotion:", e);
    });
    } catch (e) {
      err("init failed:", e);
    }
  }

  // Expose trackEvent globally so other modules (analytics.js) can fire
  // dashboard events with the same session ID, ref, and external analytics.
  window.promoTrackEvent = trackEvent;

  // Boot on all page load events
  log("Controller loaded — waiting for DOMContentLoaded");
  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("turbo:load", init);
  document.addEventListener("turbolinks:load", init);
})();
